// フィルターの種類を定義
export const FILTERS = [
  { id: 'all', name: '全て表示' },
  { id: 'dueAndNotConfirmed', name: '宿題期限あり＆未確認' },
  { id: 'noTestDate', name: '確認テスト日時未設定' },
  { id: 'failedConfirmation', name: '最終確認が不合格' },
];

// 定数: 科目リスト
export const SUBJECTS = [
  { id: 'english', name: '英語' },
  { id: 'math', name: '数学' },
  { id: 'japanese', name: '国語' },
  { id: 'science', name: '理科' },
  { id: 'social', name: '社会' }
];

// 学年リスト
export const GRADES = [
  { id: 'shougaku1', name: '小1' },
  { id: 'shougaku2', name: '小2' },
  { id: 'shougaku3', name: '小3' },
  { id: 'shougaku4', name: '小4' },
  { id: 'shougaku5', name: '小5' },
  { id: 'shougaku6', name: '小6' },
  { id: 'chuugaku1', name: '中1' },
  { id: 'chuugaku2', name: '中2' },
  { id: 'chuugaku3', name: '中3' },
  { id: 'koukou1', name: '高1' },
  { id: 'koukou2', name: '高2' },
  { id: 'koukou3', name: '高3' }
]; 